import { Locale } from '../app/locale/resolveLocale';

export type ChallengePayload = {
  typeId: string;
  locale?: Locale;
  seed?: string;
  sceneCodes: string[];
};

const validChallengePattern = /^\d{2}(?:\.\d{2})*$/;

export function buildTypeSharePath({
  locale,
  typeId,
  sceneCodes
}: {
  locale: Locale;
  typeId: string;
  sceneCodes: string[];
}): string {
  const localePath = locale === 'zh-CN' ? 'zh' : 'en';
  const challenge = sceneCodes.join('.');

  return `/${localePath}/types/${encodeURIComponent(typeId)}/?from=share&challenge=${encodeURIComponent(challenge)}`;
}

export function challengeHrefFromShareParams(typeId: string, search: string): string {
  const params = new URLSearchParams(search);
  const challenge = params.get('challenge');
  const encodedTypeId = encodeURIComponent(typeId);

  if (!challenge || !validChallengePattern.test(challenge)) {
    return `/challenge?t=${encodedTypeId}`;
  }

  return `/challenge/play?t=${encodedTypeId}&c=${encodeURIComponent(challenge)}`;
}

export function parseChallengePayload(search: string): ChallengePayload {
  const params = new URLSearchParams(search);
  const localeParam = params.get('l');
  const locale = localeParam === 'zh-CN' || localeParam === 'en' ? localeParam : undefined;

  return {
    typeId: params.get('t') ?? 'joke_shield_deflector',
    locale,
    seed: params.get('s') ?? undefined,
    sceneCodes: (params.get('c') ?? '').split('.').filter(Boolean)
  };
}
